module.exports = __webpack_public_path__ + "img/zcdgl.217225c3.png";